module.exports = __webpack_public_path__ + "img/pro_drsj.499a8ada.svg";